// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__tOK9-","name":"ConsentHeader_name__3Nh7B","birthday":"ConsentHeader_birthday__32fa2","skeleton":"ConsentHeader_skeleton__3O_OT"};